import React, { memo, useMemo } from 'react';
import { AlertTriangle, CheckCircle, XCircle, Info } from 'lucide-react';

const getAlertStyles = (variant) => {
  switch (variant) {
    case 'success':
      return 'bg-green-50 text-green-800 border-green-200';
    case 'warning':
      return 'bg-yellow-50 text-yellow-800 border-yellow-200';
    case 'destructive':
      return 'bg-red-50 text-red-800 border-red-200';
    default:
      return 'bg-blue-50 text-blue-800 border-blue-200';
  }
};

const getAlertIcon = (variant) => {
  switch (variant) {
    case 'success':
      return CheckCircle;
    case 'warning':
      return AlertTriangle;
    case 'destructive':
      return XCircle;
    default:
      return Info;
  }
};

export const Alert = memo(({ children, variant = 'default', className = '', ...props }) => {
  const Icon = useMemo(() => getAlertIcon(variant), [variant]);
  const styles = useMemo(() => getAlertStyles(variant), [variant]);
  
  return (
    <div 
      className={`relative w-full rounded-lg border p-4 flex items-start gap-3 transition-all duration-200 ${styles} ${className}`}
      {...props}
    >
      <Icon className="w-4 h-4 mt-0.5 flex-shrink-0" />
      <div className="flex-1">
        {children}
      </div>
    </div>
  );
});

export const AlertDescription = memo(({ children, className = '', ...props }) => (
  <div 
    className={`text-sm ${className}`}
    {...props}
  >
    {children}
  </div>
));

export default Alert;
